/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Magasin } from '../../models/magasin';

export interface GetMagasinByTechnicien$Params {
  /**
   * dk code technicien
   */
  'dk-code-ressource': string;
}

export function getMagasinByTechnicien(
  http: HttpClient,
  rootUrl: string,
  params: GetMagasinByTechnicien$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<Magasin>>> {
  const rb = new RequestBuilder(rootUrl, getMagasinByTechnicien.PATH, 'get');
  if (params) {
    rb.path('dk-code-ressource', params['dk-code-ressource'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Magasin>>;
    })
  );
}

getMagasinByTechnicien.PATH = '/v1/magasins/{dk-code-ressource}';
